import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Button from '../../common/Button';
import './RefundModal.css';

const formatCurrency = (n) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number(n || 0));

const RefundModal = ({ payment, onClose, onConfirm }) => {
  const [refundAmount, setRefundAmount] = useState('');
  const [refundNote, setRefundNote] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  const maxRefundAmount = payment.amount - (payment.refundAmount || 0);
  const isPartiallyRefunded = (payment.refundAmount || 0) > 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const amount = Number(refundAmount);
    
    if (!amount || amount <= 0) {
      alert('El monto del reembolso debe ser mayor a 0');
      return;
    }

    if (amount > maxRefundAmount) {
      alert(`El monto del reembolso no puede ser mayor a ${formatCurrency(maxRefundAmount)}`);
      return;
    }

    setIsProcessing(true);
    try {
      await onConfirm(amount, refundNote.trim());
    } catch (error) {
      console.error(error);
      alert('Error al procesar el reembolso: ' + error.message);
    }
    setIsProcessing(false);
  };

  return ReactDOM.createPortal(
    <div className="refund-modal-overlay" onClick={onClose}>
      <div className="refund-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="refund-modal-header">
          <h2>Reembolsar Pago</h2>
          <button className="refund-modal-close" onClick={onClose} disabled={isProcessing}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="refund-payment-info">
          <div className="payment-details">
            <h3>Detalles del Pago</h3>
            <div className="detail-row">
              <span className="label">Monto original:</span>
              <span className="value">{formatCurrency(payment.amount)}</span>
            </div>
            {isPartiallyRefunded && (
              <div className="detail-row">
                <span className="label">Ya reembolsado:</span>
                <span className="value refund-amount">-{formatCurrency(payment.refundAmount)}</span>
              </div>
            )}
            <div className="detail-row total-row">
              <span className="label">Disponible para reembolso:</span>
              <span className="value available-amount">{formatCurrency(maxRefundAmount)}</span>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="refund-form">
          <div className="form-group">
            <label htmlFor="refundAmount">Monto a Reembolsar *</label>
            <div className="input-group">
              <span className="input-prefix">$</span>
              <input
                id="refundAmount"
                type="text"
                inputMode="decimal"
                value={refundAmount}
                onChange={(e) => setRefundAmount(e.target.value)}
                placeholder="0.00"
                required
                disabled={isProcessing}
                className="currency-input"
              />
            </div>
            <div className="input-hint">
              Monto máximo: {formatCurrency(maxRefundAmount)}
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="refundNote">Motivo del Reembolso</label>
            <textarea
              id="refundNote"
              value={refundNote}
              onChange={(e) => setRefundNote(e.target.value)}
              placeholder="Ingrese el motivo del reembolso (opcional)"
              rows={3}
              disabled={isProcessing}
            />
          </div>

          <div className="refund-modal-actions">
            <Button 
              type="button" 
              variant="outline" 
              onClick={onClose}
              disabled={isProcessing}
            >
              Cancelar
            </Button>
            <Button 
              type="submit" 
              variant="danger" 
              disabled={isProcessing || !refundAmount}
              icon={isProcessing ? "fas fa-spinner fa-spin" : "fas fa-undo"}
            >
              {isProcessing ? 'Procesando...' : 'Reembolsar'}
            </Button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default RefundModal;